import LogoLink from "@casino/legacy/client/components/Vip/NewVip/BrandLogo/LogoLink";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import { cn } from "@workspace/frontend-ui";
import Logo from "../../Logo";

type Props = {
  children: React.ReactNode;
  isPopover?: boolean;
};

const HeaderWrapper: FC<Props> = ({ children, isPopover = false }) => {
  const { isMobile } = useAgentData();

  if (isPopover) {
    return <>{children}</>;
  }
  return (
    <div className={cn("grid gap-12", isMobile && "mt-0 gap-4")}>
      <LogoLink href="/">
        <Logo />
      </LogoLink>
      {children}
    </div>
  );
};
export default HeaderWrapper;
